module.exports = __webpack_public_path__ + "static/media/calculadora-8.223edf03.png";